export const GET_SEGMENTS = 'segments/GET_SEGMENTS'
export const GET_SEGMENTS_SUCCESSFUL = 'segments/GET_SEGMENTS_SUCCESSFUL'
export const GET_SEGMENTS_FAILURE = 'segments/GET_SEGMENTS_FAILURE'
